// 吃瓜图集 - 静态演示数据（展示信息结构，事件标题均为泛指演示标题）

export interface HotItem {
  title: string;
  cat: string;
  hot: number;
  delta: number;
  reads: string;
  updated: string;
}

export const categories: {
  name: string;
  slug: string;
  icon: string;
  count: number;
  desc: string;
  img: string;
}[] = [
  {
    name: "娱乐八卦",
    slug: "yule",
    icon: "ri-movie-2-line",
    count: 2180,
    desc: "明星动态、通告前后、片场花絮与圈内传闻的时间线整理。",
    img: "https://readdy.ai/api/search-image?query=editorial%20abstract%20art%20collage%20in%20warm%20cream%20and%20coral%20tone%2C%20soft%20shapes%20and%20film%20strips%20motif%2C%20minimal%20magazine%20cover%20style%2C%20flat%20illustration%2C%20high%20detail%2C%20no%20faces&width=520&height=520&seq=cat-yule-01&orientation=squarish",
  },
  {
    name: "网红主播",
    slug: "wanghong",
    icon: "ri-live-line",
    count: 1642,
    desc: "直播前后、带货翻车、公会纷争与主播出圈事件合集。",
    img: "https://readdy.ai/api/search-image?query=abstract%20editorial%20art%20of%20a%20glowing%20screen%20and%20confetti%2C%20warm%20amber%20and%20red%20palette%2C%20modern%20magazine%20illustration%2C%20flat%20graphic%2C%20no%20faces&width=520&height=520&seq=cat-live-01&orientation=squarish",
  },
  {
    name: "综艺台前",
    slug: "zongyi",
    icon: "ri-tv-line",
    count: 982,
    desc: "台前幕后、剪辑争议、导师金句与观众热议复盘。",
    img: "https://readdy.ai/api/search-image?query=abstract%20art%20composition%20of%20stage%20spotlight%20and%20curtains%2C%20warm%20champagne%20and%20terracotta%20tone%2C%20flat%20editorial%20illustration%2C%20magazine%20style%2C%20no%20faces&width=520&height=520&seq=cat-tv-01&orientation=squarish",
  },
  {
    name: "电商圈",
    slug: "dianshang",
    icon: "ri-shopping-bag-3-line",
    count: 1266,
    desc: "价格战、供应链风波、商家爆料与售后争议盘点。",
    img: "https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20parcel%20boxes%20and%20price%20tags%20in%20warm%20orange%20tones%2C%20minimal%20editorial%20flat%20illustration%2C%20soft%20shadows%2C%20no%20text&width=520&height=520&seq=cat-shop-01&orientation=squarish",
  },
  {
    name: "粉丝圈",
    slug: "fensi",
    icon: "ri-star-smile-line",
    count: 1540,
    desc: "站子争端、应援对比、澄清与反黑时间线梳理。",
    img: "https://readdy.ai/api/search-image?query=abstract%20art%20of%20floating%20stars%20and%20heart%20shapes%2C%20warm%20blush%20pink%20and%20gold%2C%20flat%20editorial%20illustration%2C%20magazine%20style%2C%20no%20faces&width=520&height=520&seq=cat-fan-01&orientation=squarish",
  },
  {
    name: "社会热议",
    slug: "shehui",
    icon: "ri-government-line",
    count: 890,
    desc: "职场、邻里、公共议题等引发广泛讨论的事件档案。",
    img: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20people%20silhouettes%20in%20conversation%20bubbles%2C%20warm%20neutral%20beige%20and%20umber%20tone%2C%20flat%20magazine%20art%2C%20no%20identifiable%20faces&width=520&height=520&seq=cat-social-01&orientation=squarish",
  },
];

export const hotEvents: HotItem[] = [
  { title: "头部主播带货口碑反转，多平台回应仍遭质疑", cat: "网红主播", hot: 982000, delta: 12, reads: "126万阅读", updated: "12分钟前" },
  { title: "新综艺开播两期，剪辑争议登上热搜词条", cat: "综艺台前", hot: 761000, delta: -4, reads: "88万阅读", updated: "38分钟前" },
  { title: "某女团成员行程疑似撞车，粉丝要求给出排期", cat: "粉丝圈", hot: 640000, delta: 7, reads: "52万阅读", updated: "1小时前" },
  { title: "品牌方公开采购清单，回应此前价格质疑", cat: "电商圈", hot: 583000, delta: 3, reads: "41万阅读", updated: "2小时前" },
  { title: "综艺嘉宾幕后连线被完整录下，聊天记录流传", cat: "娱乐八卦", hot: 512000, delta: 15, reads: "73万阅读", updated: "3小时前" },
  { title: "明星工作室深夜发文澄清，评论区两极分化", cat: "娱乐八卦", hot: 447000, delta: -9, reads: "39万阅读", updated: "4小时前" },
  { title: "直播抽奖疑似内定，观众晒出录屏对比", cat: "网红主播", hot: 398000, delta: 6, reads: "28万阅读", updated: "5小时前" },
  { title: "老牌节目宣布改版，网友对比历年海报追忆", cat: "综艺台前", hot: 322000, delta: 1, reads: "19万阅读", updated: "6小时前" },
];

export const timelineSteps: { time: string; title: string; desc: string }[] = [
  { time: "第一天 上午", title: "一张截图引爆讨论", desc: "一张被隐去敏感信息的聊天记录截图在社交平台流传，讨论聚焦在沟通方式与信息差上。" },
  { time: "第二天 晚间", title: "当事方公开回应", desc: "相关方就网络流传内容作出书面回应，说明背景与处理情况，评论区出现两派观点。" },
  { time: "第三天", title: "第三方晒出对比证据", desc: "多位网友发布朋友圈与平台动态的对照图，帮助还原对话时间线与来龙去脉。" },
  { time: "第四天 深夜", title: "发布澄清长文", desc: "当事主体发布长文逐条回应质疑，事件热度回落并进入复盘讨论阶段。" },
  { time: "持续更新", title: "图集归档整理", desc: "本事件相关截图、回应与评论已按时间顺序整理归档，持续补充后续动态。" },
];

export const galleryTabs: {
  label: string;
  icon: string;
  note: string;
  imgs: string[];
}[] = [
  {
    label: "聊天记录",
    icon: "ri-chat-3-line",
    note: "隐去隐私后的对话截图，按时间线排列，便于比对前后说法。",
    imgs: [
      "https://readdy.ai/api/search-image?query=minimal%20chat%20app%20interface%20mockup%20with%20generic%20message%20bubbles%20in%20warm%20cream%20background%2C%20soft%20rounded%20ui%2C%20no%20readable%20personal%20text%2C%20flat%20editorial%20illustration&width=700&height=760&seq=gal-chat-01&orientation=portrait",
      "https://readdy.ai/api/search-image?query=phone%20screen%20mockup%20showing%20neutral%20conversation%20thread%2C%20warm%20beige%20tone%2C%20blurred%20message%20content%2C%20flat%20ui%20illustration&width=700&height=760&seq=gal-chat-02&orientation=portrait",
    ],
  },
  {
    label: "朋友圈",
    icon: "ri-community-line",
    note: "公开可见的动态截图整理，含发布时间与点赞回复分布。",
    imgs: [
      "https://readdy.ai/api/search-image?query=social%20feed%20post%20mockup%20with%20generic%20cards%20and%20reaction%20icons%2C%20warm%20neutral%20palette%2C%20no%20identifiable%20content%2C%20flat%20editorial%20illustration&width=700&height=760&seq=gal-feed-01&orientation=portrait",
      "https://readdy.ai/api/search-image?query=mobile%20feed%20layout%20with%20generic%20text%20and%20image%20cards%2C%20warm%20grey%20and%20cream%2C%20minimal%20flat%20illustration%20style%2C%20no%20faces&width=700&height=760&seq=gal-feed-02&orientation=portrait",
    ],
  },
  {
    label: "公开评论",
    icon: "ri-chat-1-line",
    note: "评论区代表性观点摘录，保留公开讨论的多元声音。",
    imgs: [
      "https://readdy.ai/api/search-image?query=comments%20thread%20ui%20mockup%20with%20generic%20user%20icons%20and%20neutral%20text%20lines%2C%20warm%20amber%20background%2C%20flat%20editorial%20illustration%2C%20no%20identifiable%20people&width=700&height=760&seq=gal-cmt-01&orientation=portrait",
      "https://readdy.ai/api/search-image?query=discussion%20board%20grid%20mockup%20generic%20posts%2C%20soft%20warm%20tone%2C%20minimal%20ui%20illustration%2C%20no%20real%20text&width=700&height=760&seq=gal-cmt-02&orientation=portrait",
    ],
  },
];

export interface FeedItem {
  id: string;
  title: string;
  cat: string;
  excerpt: string;
  tag: string;
  date: string;
  reads: string;
  imgs: string[];
}

export const latestFeed: FeedItem[] = [
  {
    id: "e-01",
    title: "带货口碑反转事件 · 全程时间线与回应对比",
    cat: "网红主播",
    excerpt: "从首张爆料截图到各方回应，本文用可检索的时间线串联聊天记录、直播间录屏与公开声明。",
    tag: "专题图集",
    date: "09-07",
    reads: "126万",
    imgs: ["https://readdy.ai/api/search-image?query=abstract%20collage%20of%20phone%20screens%20and%20newspaper%20clippings%2C%20warm%20coral%20and%20cream%2C%20editorial%20flat%20illustration%2C%20no%20faces&width=820&height=560&seq=feed-live-01&orientation=landscape"],
  },
  {
    id: "e-02",
    title: "新综艺剪辑争议复盘：到底争的是什么",
    cat: "综艺台前",
    excerpt: "观众晒出逐帧对比与幕后花絮截图，我们把这些零散线索串成一条清晰的时间线。",
    tag: "事件复盘",
    date: "09-07",
    reads: "88万",
    imgs: ["https://readdy.ai/api/search-image?query=abstract%20art%20of%20film%20editing%20timeline%20and%20clapperboard%2C%20warm%20terracotta%20palette%2C%20flat%20editorial%20magazine%20illustration%2C%20no%20faces&width=820&height=560&seq=feed-tv-01&orientation=landscape"],
  },
  {
    id: "e-03",
    title: "女团成员行程撞车：粉丝诉求与官方排期的博弈",
    cat: "粉丝圈",
    excerpt: "整理站子发布的对比图与应援时间，还原这场排期争议的全过程与各方说法。",
    tag: "粉丝应援",
    date: "09-06",
    reads: "52万",
    imgs: ["https://readdy.ai/api/search-image?query=abstract%20collage%20of%20calendar%20and%20star%20icons%20in%20blush%20and%20gold%2C%20flat%20editorial%20illustration%2C%20minimal%2C%20no%20faces&width=820&height=560&seq=feed-fan-01&orientation=landscape"],
  },
  {
    id: "e-04",
    title: "品牌公开采购清单，逐条回应价格质疑",
    cat: "电商圈",
    excerpt: "把质疑帖、采购单截图与公开回应放在一起对比，帮你看清争议的来龙去脉。",
    tag: "商家回应",
    date: "09-06",
    reads: "41万",
    imgs: ["https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20documents%20and%20magnifying%20glass%2C%20warm%20orange%20tone%2C%20flat%20editorial%20illustration%2C%20no%20faces&width=820&height=560&seq=feed-shop-01&orientation=landscape"],
  },
  {
    id: "e-05",
    title: "幕后连线被完整录下：一场风波从何而起",
    cat: "娱乐八卦",
    excerpt: "以朋友圈截图与连线音频文字稿为主线，逐条梳理本次舆论发酵的关键节点。",
    tag: "全程复盘",
    date: "09-05",
    reads: "73万",
    imgs: ["https://readdy.ai/api/search-image?query=abstract%20audio%20wave%20and%20social%20icons%20collage%2C%20warm%20ink%20and%20coral%2C%20flat%20editorial%20magazine%20illustration%2C%20no%20faces&width=820&height=560&seq=feed-ent-01&orientation=landscape"],
  },
  {
    id: "e-06",
    title: "明星工作室深夜澄清，评论区的两个方向",
    cat: "娱乐八卦",
    excerpt: "汇总澄清长文要点与两派代表性评论，标注信息来源，方便你自行判断。",
    tag: "观点对比",
    date: "09-05",
    reads: "39万",
    imgs: ["https://readdy.ai/api/search-image?query=abstract%20art%20of%20two%20opposing%20speech%20bubbles%2C%20warm%20neutral%20background%2C%20flat%20editorial%20illustration%2C%20balanced%20composition%2C%20no%20faces&width=820&height=560&seq=feed-cmt-01&orientation=landscape"],
  },
  {
    id: "e-07",
    title: "直播抽奖被指内定：录屏与规则逐条比对",
    cat: "网红主播",
    excerpt: "多段录屏显示抽奖过程存在时间差，我们整理规则原文与实测截图供参考。",
    tag: "实测对比",
    date: "09-04",
    reads: "28万",
    imgs: ["https://readdy.ai/api/search-image?query=abstract%20art%20of%20gift%20box%20and%20screen%20frames%2C%20warm%20golden%20and%20red%2C%20flat%20editorial%20illustration%2C%20no%20faces&width=820&height=560&seq=feed-gift-01&orientation=landscape"],
  },
  {
    id: "e-08",
    title: "老牌节目改版，网友晒历年海报追忆",
    cat: "综艺台前",
    excerpt: "从视觉升级到阵容更替，用一组海报与节目单截图带你回顾这档节目的变迁。",
    tag: "情怀盘点",
    date: "09-04",
    reads: "19万",
    imgs: ["https://readdy.ai/api/search-image?query=abstract%20collage%20of%20posters%20through%20time%20in%20warm%20vintage%20tones%2C%20flat%20editorial%20illustration%2C%20minimal%2C%20no%20faces&width=820&height=560&seq=feed-vint-01&orientation=landscape"],
  },
];

export const faqs: { q: string; a: string }[] = [
  { q: "吃瓜图集收录的是哪些内容？", a: "吃瓜图集按事件整理网络上公开流传的聊天截图、朋友圈截图、微博动态、评论区观点与相关回应。所有图集均按时间线排列，并对涉及隐私的信息做打码处理，隐去可识别个人身份与联系方式。" },
  { q: "截图来源可靠吗？如何标注？", a: "每套图集会标注信息来源类型（如公开动态、网友投稿、媒体转载），并对存在多方说法的内容做并列表述。我们建议以当事主体的官方回应为准，站内整理仅作事件脉络参考。" },
  { q: "涉及个人隐私的内容会如何处理？", a: "站内图集在发布前会对头像、手机号、账号ID等可识别信息进行打码；仅收录可公开检索或已获得授权的材料。涉及真实个人核心隐私的内容不予收录。" },
  { q: "我想投稿或提供事件线索，该怎么做？", a: "可在站内任意页底通过投稿入口与我们联系。投稿请务必隐去第三方隐私信息，并附上时间与来源说明，审核通过后才会进入整理流程。" },
  { q: "站内内容涉及我的权益，如何申请处理？", a: "如你发现站内内容涉及你的权益或相关方权益，可通过页脚版权联系邮箱发送处理申请，说明对应页面与具体截图，我们将依流程在核实后及时处理。" },
  { q: "为什么同一个事件会有不同说法？", a: "事件发酵期间信息往往零散且来源多元。吃瓜图集采用并列整理的方式呈现多方观点，并用时间线还原先后顺序，帮助读者自行比对判断，而非替读者下结论。" },
];

export const disclaimerText: string[] = [
  "本站图集内容整理自公开可检索的网络信息与用户授权投稿，用于信息梳理与内容还原。",
  "站内对头像、联系方式、账号ID等可识别隐私均作打码处理；不收录涉及真实个人核心隐私的内容。",
  "事件存在多方说法时，站内采取并列整理呈现，相关争议以当事主体公开回应与权威平台处理结果为准。",
  "如内容涉及你的权益，请通过页脚版权联系邮箱申请处理，我们将在核实后依流程及时响应。",
];